export default __webpack_public_path__ + "static/media/home-banner-desktop.3bc19d38.png";